export let exportHeader = [
  {key: 'payment_company', text: '付款公司'},
  {key: 'payment_company_account', text: '付款账户/银行账号'},
  {key: 'id', text: '付款ID'},
  {key: 'status', text: '付款状态'},
  {key: 'applicant_name', text: '申请人'},
  {key: 'department_name', text: '申请人部门'},
  {key: 'type', text: '付款类型'},
  {key: 'desc', text: '付款说明'},
  {key: 'expected_date', text: '加急付款日期'},
  {key: 'receipt_name', text: '收款方名称'},
  {key: 'bank_account', text: '银行账号'},
  {key: 'bank', text: '开户银行支行'},
  {key: 'bank_headquarters', text: '开户银行总行'},
  {key: 'apply_amount', text: '应付金额'},
  {key: 'paid_amount_total', text: '实付金额'},
  {key: 'paid_date', text: '付款日期'},
]


export let exportDetailHeader = [
  {key: 'payment_company', text: '付款公司'},
  {key: 'payment_company_account', text: '付款账户/银行账号'},
  {key: 'id', text: '付款ID'},
  {key: 'applicant_name', text: '申请人'},
  {key: 'department_name', text: '申请人部门'},
  {key: 'type', text: '付款类型'},
  {key: 'desc', text: '付款说明'},
  {key: 'status', text: '付款状态'},
  {key: 'detail_paid_amount', text: '实付金额'},
  {key: 'detail_paid_no_tax_amount', text: '未税实付金额'},
  {key: 'detail_project_name', text: '项目名称'},
  {key: 'detail_project_number', text: '项目编号'},
  {key: 'detail_department_name', text: '费用承担部门'},
  {key: 'detail_first_subject', text: '一级科目'},
  {key: 'detail_second_subject', text: '二级科目'},
  {key: 'detail_invoice_type', text: '发票类型'},
  {key: 'detail_tax_rate', text: '税率'},
  {key: 'detail_apply_amount', text: '应付金额'},
  {key: 'paid_date', text: '付款日期'},
  {key: 'paid_to_type_name', text: '付款主体'},
  {key: 'receipt_id', text: '收款方ID'},
  {key: 'receipt_name', text: '收款方名称'},
  {key: 'bank_account', text: '银行账号'},
  {key: 'bank', text: '开户银行支行'},
  {key: 'bank_headquarters', text: '开户银行总行'},
  {key: 'detail_desc', text: '摘要'},
]

export let exportWriteOffDetailHeader = [
  {key: 'payment_company', text: '付款公司'},
  {key: 'id', text: '付款ID'},
  {key: 'applicant_name', text: '申请人'},
  {key: 'department_name', text: '申请人部门'},
  {key: 'type', text: '付款类型'},
  {key: 'desc', text: '付款说明'},
  {key: 'status', text: '付款状态'},
  {key: 'paid_to_type_name', text: '付款主体'},
  {key: 'receipt_id', text: '收款方ID'},
  {key: 'receipt_name', text: '收款方名称'},
  {key: 'detail_project_name', text: '项目名称'},
  {key: 'detail_project_number', text: '项目编号'},
  {key: 'detail_department_name', text: '费用承担部门'},
  {key: 'detail_first_subject', text: '一级科目'},
  {key: 'detail_second_subject', text: '二级科目'},
  {key: 'detail_invoice_type', text: '发票类型'},
  {key: 'detail_tax_rate', text: '税率'},
  {key: 'detail_amount_with_taxed', text: '含税冲销金额'},
  {key: 'detail_amount_untaxed', text: '未税冲销金额'},
  {key: 'detail_write_off_at', text: '冲销日期'},
  {key: 'detail_desc', text: '摘要'},
]

export let exportWriteOffStatusHeader = [
  {key: 'payment_company', text: '付款公司'},
  {key: 'id', text: '付款ID'},
  {key: 'applicant_name', text: '申请人'},
  {key: 'department_name', text: '申请人部门'},
  {key: 'type', text: '付款类型'},
  {key: 'desc', text: '付款说明'},
  {key: 'paid_to_type_name', text: '付款主体'},
  {key: 'receipt_id', text: '收款方ID'},
  {key: 'receipt_name', text: '收款方名称'},
  {key: 'paid_amount_total', text: '实付金额'},
  {key: 'written_off_amount', text: '已冲销金额'},
  {key: 'wait_write_off', text: '未冲销金额'},
  {key: 'status', text: '付款状态'},
  {key: 'write_off_status_txt', text: '冲销状态'},
  {key: 'export_at', text: '导出时间'},
]

export let exportSearchAggregateheader = [
  {key: 'name', text: '状态'},
  {key: 'apply_total', text: '应付金额'},
  {key: 'paid_total', text: '实付金额'},
]

export let defalutValueSummary = {
  5: {apply_total: 0, paid_total: 0, name: '待会计审批'},
  6: {apply_total: 0, paid_total: 0, name: '待财务经理审批'},
  7: {apply_total: 0, paid_total: 0, name: '待付款'},
  other: {apply_total: 0, paid_total: 0, name: '其他'},
  paid: {apply_total: 0, paid_total: 0, name: '已付款'},
  pending: {apply_total: 0, paid_total: 0, name: '待审批'},
  summary: {apply_total: 0, paid_total: 0, name: '总计'}
}



// WEBPACK FOOTER //
// ./src/views/payment-manager/components/payment-manager-export-header.js